export default __webpack_public_path__ + "static/media/empower-girl.3963e083.jpg";